import axios from '@/utils/api'

const state = {
}

const getters = {
}

const actions = {
  async getUsuarioPerfilTipo ({ commit }, codigo) {
    const response = await axios({
      method: 'GET',
      url: `vinculoDistribuicaoProcesso/getUsuarioPerfilTipo/${codigo}`
    })
    return response
  },
  async getPerfilSetor ({ commit }, codigo) {
    const response = await axios({
      method: 'GET',
      url: `vinculoDistribuicaoProcesso/getPerfilSetor/${codigo}`
    })
    return response
  },
  saveVinculosUsuario ({ commit }, vinculo) {
    return axios({
      method: 'POST',
      data: vinculo.vinculos,
      url: `vinculoDistribuicaoProcesso/usuario/${vinculo.id}/atualizarVinculos/${vinculo.codigo}`
    })
  },
  saveVinculosPerfil ({ commit }, vinculo) {
    return axios({
      method: 'POST',
      data: vinculo.vinculos,
      url: `vinculoDistribuicaoProcesso/perfil/${vinculo.id}/atualizarVinculos/${vinculo.codigo}`
    })
  }
}
const mutations = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/analise/vinculoDistribuicaoProcesso.js